const TRANSLATIONS = {
  "year": {
    "en": { text: "year", abbreviation: "y" },
    "it": { text: "anno", abbreviation: "a" },
    "ru": { text: "", abbreviation: "Г."},
    "pl": { text: "", abbreviation: "r"},
    "nl": { text: "", abbreviation: "j"},
    "pt": { text: "", abbreviation: "a"},
    "es": { text: "año", abbreviation: "Año" },
    "fr": { text: "", abbreviation: "y" }
  },
  "month": {
    "en": { text: "month", abbreviation: "m" },
    "it": { text: "mese", abbreviation: "m" },
    "ru": { text: "", abbreviation: "М."},
    "pl": { text: "", abbreviation: "m"},
    "nl": { text: "", abbreviation: "m"},
    "pt": { text: "", abbreviation: "m"},
    "es": { text: "", abbreviation: "m" },
    "fr": { text: "", abbreviation: "m" }
  },
  "week": {
    "en": { text: "week", abbreviation: "w" },
    "it": { text: "settimana", abbreviation: "s" },
    "ru": { text: "", abbreviation: "Нед."},
    "pl": { text: "", abbreviation: "t"},
    "nl": { text: "", abbreviation: "w"},
    "pt": { text: "", abbreviation: "s"},
    "es": { text: "", abbreviation: "Sem" },
    "fr": { text: "", abbreviation: "w" }
  },
  "day": {
    "en": { text: "day", abbreviation: "d" },
    "it": { text: "giorno", abbreviation: "g" },
    "ru": { text: "", abbreviation: "Д."},
    "pl": { text: "", abbreviation: "d"},
    "nl": { text: "", abbreviation: "d"},
    "pt": { text: "", abbreviation: "d"},
    "es": { text: "", abbreviation: "D" },
    "fr": { text: "", abbreviation: "d" }
  },
  "hour": {
    "en": { text: "hour", abbreviation: "h" },
    "it": { text: "ora", abbreviation: "o" },
    "ru": { text: "", abbreviation: "Ч."},
    "pl": { text: "", abbreviation: "g"},
    "nl": { text: "", abbreviation: "u"},
    "pt": { text: "", abbreviation: "h"},
    "es": { text: "", abbreviation: "h" },
    "fr": { text: "", abbreviation: "h" }
  },
  "minute": {
    "en": { text: "minute", abbreviation: "m" },
    "it": { text: "minuto", abbreviation: "m" },
    "ru": { text: "", abbreviation: ""},
    "pl": { text: "", abbreviation: ""},
    "nl": { text: "", abbreviation: ""},
    "pt": { text: "", abbreviation: ""},
    "es": { text: "", abbreviation: "" },
    "fr": { text: "", abbreviation: "" }
  },
  "matchstatus-upcoming": {
    "en": { text: "upcoming", abbreviation: "upcoming" },
    "it": { text: "in arrivo", abbreviation: "in arrivo" },
    "ru": { text: "расписание", abbreviation: "расписание" },
    "pl": { text: "wkrótce", abbreviation: "wkrótce" },
    "nl": { text: "aanstaande", abbreviation: "aanstaande" },
    "pt": { text: "próximo", abbreviation: "próximo" },
    "es": { text: "próximo", abbreviation: "próximo" },
    "fr": { text: "", abbreviation: "" }

  },
  "matchstatus-live": {
    "en": { text: "live", abbreviation: "live" },
    "it": { text: "live", abbreviation: "live" },
    "ru": { text: "Матч идет", abbreviation: "Матч идет" },
    "pl": { text: "Na żywo", abbreviation: "Na żywo" },
    "nl": { text: "live", abbreviation: "live" },
    "pt": { text: "ao vivo", abbreviation: "ao vivo" },
    "es": { text: "en vivo", abbreviation: "en vivo" },
    "fr": { text: "", abbreviation: "" }

  },
  "matchstatus-results": {
    "en": { text: "results", abbreviation: "results" },
    "it": { text: "risultati", abbreviation: "risultati" },
    "ru": { text: "Матчи закончен", abbreviation: "Матчи закончен" },
    "pl": { text: "wyniki", abbreviation: "wyniki" },
    "nl": { text: "uitslag", abbreviation: "uitslag" },
    "pt": { text: "resultados", abbreviation: "resultados" },
    "es": { text: "resultados", abbreviation: "resultados" },
    "fr": { text: "", abbreviation: "" }
  }
}

export default TRANSLATIONS;
